<template>
  <div id="app">
    <Kakutei/>
  </div>
</template>

<script>
  import Kakutei from './components/Kakutei'

  export default {
    name : 'App',
    components : {
      Kakutei : Kakutei
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue